import {
  SeuConfig,
  SeuConfigApi,
  SeuConfigFormDefinition,
  SeuConfigFormDefinitions,
  SeuConfigPresets,
  SeuConfigSvgDefinitions,
  SeuConfigTranslationObject,
  SeuConfigTranslationSelectOption,
  SeuSetupConverter,
} from '@seu-types';

export const configConverter: SeuSetupConverter<SeuConfig, SeuConfigApi> = {
  fromApi: (input) => {
    const formDefinitions: SeuConfigFormDefinitions = {};
    const hierarchy: string[] = [];
    const svgDefinitions: SeuConfigSvgDefinitions = {};

    for (const fileName in input) {
      if (fileName.includes('.json') && fileName !== 'DE.json') {
        const item: SeuConfigFormDefinition = input[
          fileName
        ] as SeuConfigFormDefinition;
        const key = fileName.replace('.json', '');
        formDefinitions[key] = item;
      }

      if (fileName === 'hierarchy') {
        const item: string = input[fileName] as string;
        const hierarchyItems = item.split('\n');
        hierarchyItems.forEach((hierarchyItem) => {
          hierarchy.push(hierarchyItem);
        });
      }

      if (fileName.includes('.svg')) {
        const item: string = input[fileName] as string;
        const key = fileName.replace('.svg', '');
        svgDefinitions[key] = item;
      }
    }

    const translations = {
      de: input['DE.json'] as SeuConfigTranslationObject,
    };

    const allUnitsMap = new Map<string, string>();
    const allUnitKeywordsMap = new Map<string, string[]>();
    const allUnitGroups = translations.de[
      'units'
    ] as SeuConfigTranslationObject;

    Object.keys(allUnitGroups).forEach((unitGroupKey) => {
      const allUnits = allUnitGroups[
        unitGroupKey
      ] as SeuConfigTranslationSelectOption[];

      allUnits.forEach((unit: SeuConfigTranslationSelectOption) => {
        const key = unit.pythonName;
        const label = unit.displayName;
        const keywords = unit.synonyms;
        allUnitsMap.set(key, label);
        allUnitKeywordsMap.set(key, keywords);
      });
    });

    translations.de['allUnits'] = Object.fromEntries(allUnitsMap.entries());
    translations.de['allUnitKeywords'] = Object.fromEntries(
      allUnitKeywordsMap.entries()
    );

    const config = {
      formDefinitions,
      svgs: svgDefinitions,
      translations: translations,
      hierarchy,
      opexPresets: input['opexPresets.json'] as SeuConfigPresets | undefined,
      limitsPresets: input['limitsPresets.json'] as
        | SeuConfigPresets
        | undefined,
    };

    return config;
  },
};
